export interface Apis{
  // 分页查询
  selectMachineByPage: string;
  // 详情
  selectMachineByManageId: string;
  // 删除
  deleteMachine: string;
  // 编辑
  updateMachine: string;
  // 新增
  insertMachine: string;
}
export const apis: Apis = {
  selectMachineByPage: '/iparkAdmin/machine/selectMachineByPage',
  selectMachineByManageId: '/iparkAdmin/machine/selectMachineByManageId',
  deleteMachine: '/iparkAdmin/machine/deleteMachine',
  updateMachine: '/iparkAdmin/machine/updateMachine',
  insertMachine: '/iparkAdmin/machine/insertMachine'

}
